import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ShowComponent } from 'src/app/common/component/show.component';
import { DataBagService } from 'src/app/common/data-bag.service';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { LockerService } from 'src/app/common/locker.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { UuidService } from 'src/app/common/uuid.service';

import { ServiceService } from '../service.service';

@Component({
	selector: 'app-services-form',
	templateUrl: './services-form.component.html',
	styleUrls: ['./services-form.component.css'],
})
export class ServicesFormComponent extends ShowComponent implements OnInit, OnDestroy {
	protected apiType = 'bag';
	protected apiUrlAdd = '/offer/service/';
	protected apiUrl = '/offer/service/';
	protected parentComponent = 'service';
	pageTitle = 'Dodawanie';
	protected itemsBeforeDataLoad = 8;
	protected dateService: DateService = new DateService();
	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected uuid: UuidService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected question: QuestionService,
		protected loader: LoaderService,
		protected locker: LockerService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected service: ServiceService,
	) {
		super(api, bag, uuid, date, infobox, question, loader, locker, route, router);
	}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			this.router.navigate([this.parentComponent]);
		}
		if (this.route.snapshot.params['id'] == 'add') {
			this.pageFunction = 'add';
			this.service.editable = true;
			if (!this.apiUrlAdd) {
				this.apiUrlAdd = '/' + this.parentComponent + '/';
			}
		} else {
			this.pageFunction = 'edit';
			this.service.editable = false;
			this.service.data.id = this.route.snapshot.params['id'];
			this.apiUrl = this.getApiUrl();
			this.pageTitle = this.pageTitleGenerate();
		}
		this.loader.show();
		this.loadBefore();
	}
	ngOnDestroy(): void {
		this.service.resetData();
	}

	protected getApiUrl(): string {
		return this.apiUrlAdd + this.service.data.id + '/';
	}
	protected pageTitleGenerate(): string {
		return this.service.data.name + ' (ID: ' + this.service.data.id + ')';
	}

	protected loadBefore(): void {
		this.bag.get('/offer/service_type/?limit=100', (result, error) => {
			this.service.mockData.service_type = result.results;
			this.loadData();
		});
		this.bag.get('/product/?limit=999', (result, error) => {
			this.service.mockData.products = result.results;
			this.loadData();
		});
		this.bag.get('/product/kind/', (result, error) => {
			this.service.mockData.kinds = result.results;
			this.loadData();
		});
		this.bag.get('/reservation/channel/', (result, error) => {
			this.service.mockData.channels = result.results;
			this.loadData();
		});
		this.bag.get('/multimedia/file/', (result, error) => {
			this.service.mockData.multimedias = result.results;
			this.loadData();
		});
		this.bag.get('/person_type/', (result, error) => {
			this.service.mockData.person_types = result.results;
			this.loadData();
		});
		this.bag.get('/location/basic/?location_kind=CR&limit=100', (result, error) => {
			this.service.mockData.locations = result.results;
			this.loadData();
		});
		this.bag.get('/offer/service/?limit=100', (result, error) => {
			this.service.mockData.services = result.results;
			this.loadData();
		});
	}

	protected doGet() {
		this.bag.get(this.apiUrl, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.service.data = this.convertData(result);
			this.afterLoadDataGet();
			this.loader.hide();
			this.pageTitle = this.pageTitleGenerate();
			this.service.dataLoaded$.next();
		});
	}
	protected doAdd() {
		this.bag.post(this.apiUrlAdd, this.submitConvert(this.service.data), (result, error) => {
			this.service.data.id = result.id;
			this.afterSend(result, error);
		});
	}

	protected doEdit() {
		this.bag.put(this.apiUrl, this.submitConvert(this.service.data), (result, error) => {
			this.afterSend(result, error);
		});
	}
	protected afterSend(result, error) {
		this.loader.hide();
		if (error) {
			this.api2date(this.service.data.sell);
			this.api2date(this.service.data.departures);
		}
		this.router.navigate([this.parentComponent, this.service.data.id]);
		this.loadData();
		this.pageFunction = 'edit';
		this.service.editable = false;
		this.pageTitle = this.pageTitleGenerate();
		this.apiUrl = this.getApiUrl();
		this.infobox.success('Zapisano');
		this.submitAfter();
	}
	editUnlock() {
		this.service.editable = true;
	}

	protected submitConvert(data) {
		data.serviceMultimedias.forEach((element) => {
			if (element.id == null) {
				delete element.id;
			}
			element.multimedia = element.multimedia.id;
		});
		return data;
	}

	protected afterLoadData() {
		this.api2date(this.service.data.sell);
		this.api2date(this.service.data.departures);
		if (
			!this.service.data.sell.lower &&
			!this.service.data.sell.upper &&
			!this.service.data.departures.lower &&
			!this.service.data.departures.upper &&
			this.service.data.transport == 'A'
		) {
			this.service.limits = true;
		}
		// delete this.data.sell['empty'] && delete this.data.departures['empty'];
		this.service.mockData.product_whitelist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'PRODUCT',
			'W',
		);
		this.service.mockData.product_blacklist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'PRODUCT',
			'B',
		);
		this.service.mockData.location_whitelist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'LOCATION',
			'W',
		);
		this.service.mockData.location_blacklist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'LOCATION',
			'B',
		);
		this.service.mockData.count_services_whitelist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'COUNT_PERCENTAGE',
			'W',
		);
		this.service.mockData.count_services_blacklist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'COUNT_PERCENTAGE',
			'B',
		);
		this.service.mockData.services_whitelist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'SELF',
			'W',
		);
		this.service.mockData.services_blacklist = this.map_service_rules_to_array(
			this.service.data.serviceRules,
			'SELF',
			'B',
		);
	}
	private api2date(obj) {
		if (obj.lower) {
			obj.lower = new Date(obj.lower);
		}
		if (obj.upper) {
			obj.upper = new Date(obj.upper);
		}
	}
	private date2api(obj) {
		if (obj.lower) {
			obj.lower = this.dateService.toUtcDate(obj.lower);
		}
		if (obj.upper) {
			obj.upper = this.dateService.toUtcDate(obj.upper);
		}
	}

	submitBefore(): void {
		if (this.service.limits) {
			this.service.data.sell.lower = null;
			this.service.data.sell.upper = null;
			this.service.data.departures.lower = null;
			this.service.data.departures.upper = null;
		}
		this.date2api(this.service.data.sell);
		this.date2api(this.service.data.departures);
		this.service.data.serviceRules = this.create_service_rules(
			this.service.mockData.product_whitelist,
			'W',
			'PRODUCT',
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.product_blacklist, 'B', 'PRODUCT'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.location_whitelist, 'W', 'LOCATION'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.location_blacklist, 'B', 'LOCATION'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.count_services_whitelist, 'W', 'COUNT_PERCENTAGE'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.count_services_blacklist, 'B', 'COUNT_PERCENTAGE'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.services_whitelist, 'W', 'SELF'),
		);
		this.service.data.serviceRules = this.service.data.serviceRules.concat(
			this.create_service_rules(this.service.mockData.services_blacklist, 'B', 'SELF'),
		);
	}
	private create_service_rules(array, rule, entity_name) {
		if (!array) {
			return [];
		}
		return array.map((x) => {
			return {
				rule: rule,
				entityName: entity_name,
				entityId: x,
			};
		});
	}
	private map_service_rules_to_array(array, type, rule) {
		if (!array) {
			return [];
		}
		return array
			.map((service) => {
				if (service.entityName != type) {
					return false;
				}
				if (service.rule != rule) {
					return false;
				}
				return service.entityId;
			})
			.filter((obj) => obj != false);
	}
}
